export * from './offer-detail';
